import React, { Component } from 'react';

import { Helmet } from 'react-helmet';
import { createBrowserRouter, RouterProvider } from "react-router";

import LayoutPrincipal from "./pages/Layout/LayoutPrincipal";
import LayoutAuth from "./pages/Layout/LayoutAuth";
import PaginaNaoExiste from "./pages/PaginaNaoExiste";

import Loader from './components/ui/loader';

import 'animate.css/animate.css'

import { Toast } from 'primereact/toast';
import LoginPage        from './pages/Login/LoginPage';
import EsqueciSenhaPage from './pages/Login/EsqueciSenhaPage';
import { UtilService } from 'hay-core-react';
import RotasService, { rotasPermitidas } from './service/RotasService';
import RotaProfundaGuard from './pages/Layout/RotaProfundaGuard';
import { ConfirmDialog } from 'primereact/confirmdialog';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            configuracao: { traducao: window.traducao || [] },
            permissoes: {}
        }
    }

    componentDidMount() {
        window.addEventListener("showToast", (event) => {
            this.refs.toast.show(event.detail);
        });
        window.addEventListener("hideToast", (event) => {
            this.refs.toast.hide(event.detail);
        });
    }

    render() {
        const permitidos = rotasPermitidas(this.state.permissoes);
        this.router = createBrowserRouter([
            // Rotas públicas (sem autenticação)
            {
                element: <LayoutPrincipal />,
                children: [
                    {
                        path: "/login",
                        element: <LoginPage setPermissoes={(permissoes, cb) => this.setState({ permissoes }, cb)} />,
                    },
                    {
                        path: "/esqueci-senha",
                        element: <EsqueciSenhaPage />,
                    },
                    {
                        path: "/*",
                        element: <PaginaNaoExiste />,
                    },
                ],
            },
            // Rotas protegidas (exigem token em localStorage["auth"])
            {
                element: <LayoutAuth permissoes={this.state.permissoes} />,
                children: [
                    ...Object.entries(permitidos).map(([key, cfg]) => ({
                        path:    cfg.rota + '/*',
                        element: <RotaProfundaGuard
                            cfg={cfg}
                            controllerKeyAtual={key}
                            rotaRegistry={RotasService}
                            permissoes={this.state.permissoes}
                            getRouter={() => this.router}
                        />,
                    })),
                ],
            },
        ]);
        return (
            <>
                <Helmet>
                    <title>{UtilService.traduzir('main.sistema.titulo')}</title>
                    <meta name="description" content={'Heitor Trevisan Games'} />
                    <meta name="google" content="notranslate" />
                    <link className="icone-app" rel="apple-touch-icon" href={process.env.PUBLIC_URL + '/favicon.png'} />
                    <link className="icone-app" rel="icon" type="image/png" href={process.env.PUBLIC_URL + '/favicon.png'} />
                </Helmet>                
                <RouterProvider router={this.router} />
                <Loader inicializarVisivel={false} /> 
                <ConfirmDialog />
                <Toast ref={(ref) => this.refs.toast = ref} />
            </>
        )
    }
}
export default App;